var map = {
	"./apps/combinedContextLoader/combinedContextLoader.duck.js": 119,
	"./apps/comments/commentsDisplay/commentsDisplay.duck.js": 898,
	"./apps/comments/listOfComments.duck.js": 608,
	"./apps/comments/singleComment/singleComment.duck.js": 609,
	"./apps/dashboard/actionlist/actionlist.duck.js": 220,
	"./apps/dashboard/dashboard.duck.js": 899,
	"./apps/dashboard/dashboardWidget/dashboardWidget.duck.js": 900,
	"./apps/dashboard/listofdocument/listofdocument.duck.js": 901,
	"./apps/dashboard/v2dashboardwidget/v2dashboardwidget.duck.js": 902,
	"./apps/tour/tour.duck.js": 903,
	"./apps/workflow/schemaBasedEditor/components/actionButtonArrayFieldTemplate/actionButtonArrayFieldTemplate.duck.js": 904,
	"./apps/workflow/schemaBasedEditor/components/arrayFieldTemplate/arrayFieldTemplate.duck.js": 905,
	"./apps/workflow/schemaBasedEditor/components/checkboxWidget/checkboxWidget.duck.js": 906,
	"./apps/workflow/schemaBasedEditor/components/inputWidget/inputWidget.duck.js": 907,
	"./apps/workflow/schemaBasedEditor/components/primaryActionFieldTemplate/primaryActionFieldTemplate.duck.js": 908,
	"./apps/workflow/schemaBasedEditor/components/sectionTitle/sectionTitle.duck.js": 909,
	"./apps/workflow/schemaBasedEditor/components/selectWidget/selectWidget.duck.js": 910,
	"./apps/workflow/schemaBasedEditor/components/stageDropdown/stageDropdown.duck.js": 911,
	"./apps/workflow/schemaBasedEditor/components/topLevelArrayFieldTemplate/topLevelArrayFieldTemplate.duck.js": 912,
	"./apps/workflow/schemaBasedEditor/schemaBasedEditor.duck.js": 120,
	"./apps/workflow/workflowWidget/components/adminWorkflowStatus/adminWorkflowStatus.duck.js": 913,
	"./apps/workflow/workflowWidget/components/approvalHistoryModal/approvalHistoryModal.duck.js": 219,
	"./apps/workflow/workflowWidget/components/approveModal/approveModal.duck.js": 914,
	"./apps/workflow/workflowWidget/components/assignableUsersSelect/assignableUsersSelect.duck.js": 915,
	"./apps/workflow/workflowWidget/components/assignedDocuments/assignedDocuments.duck.js": 916,
	"./apps/workflow/workflowWidget/components/authorAssignedBy/authorAssignedBy.duck.js": 917,
	"./apps/workflow/workflowWidget/components/authorCompleteBy/authorCompleteBy.duck.js": 918,
	"./apps/workflow/workflowWidget/components/executiveApproval/executiveApproval.duck.js": 919,
	"./apps/workflow/workflowWidget/components/executiveApproveBy/executiveApproveBy.duck.js": 920,
	"./apps/workflow/workflowWidget/components/executiveLastApproved/executiveLastApproved.duck.js": 921,
	"./apps/workflow/workflowWidget/components/nextDocumentButton/nextDocumentButton.duck.js": 922,
	"./apps/workflow/workflowWidget/components/progressButton/progressButton.duck.js": 923,
	"./apps/workflow/workflowWidget/components/widgetHeader/widgetHeader.duck.js": 924,
	"./apps/workflow/workflowWidget/components/workflowMessage/workflowMessage.duck.js": 925,
	"./apps/workflow/workflowWidget/components/workflowSettingsModal/workflowSettingsModal.duck.js": 926,
	"./apps/workflow/workflowWidget/components/workflowSettingsModalRow/workflowSettingsModalRow.duck.js": 927,
	"./apps/workflow/workflowWidget/components/workflowStatus/workflowStatus.duck.js": 928,
	"./apps/workflow/workflowWidget/workflowWidget.duck.js": 23,
	"./contexts/account/account.duck.js": 193,
	"./contexts/document/document.duck.js": 83,
	"./contexts/heading/heading.duck.js": 81,
	"./contexts/instance/instance.duck.js": 194,
	"./contexts/organisation/organisation.duck.js": 195,
	"./contexts/project/dataTypes/groups/groups.duck.js": 50,
	"./contexts/project/dataTypes/users/users.duck.js": 55,
	"./contexts/project/project.duck.js": 66,
	"./contexts/workflowinstance/workflowinstance.duck.js": 196,
	"./globals/darkTheme.duck.js": 929,
	"./globals/dataTypes/auth/auth.duck.js": 34,
	"./globals/dataTypes/comments/comments.duck.js": 43,
	"./globals/dataTypes/login/login.duck.js": 87,
	"./globals/dataTypes/maintenance/data/data.duck.js": 88,
	"./globals/dataTypes/notificationSettings/notificationSettings.duck.js": 107,
	"./globals/dataTypes/notifications/notifications.duck.js": 103,
	"./globals/dataTypes/performanceLogs/performanceLogs.duck.js": 174,
	"./globals/dataTypes/projects/projects.duck.js": 188,
	"./globals/dataTypes/workflow/workflowEditor/workflowEditor.duck.js": 67,
	"./globals/dataTypes/workflow/workflowTasks/workflowTasks.duck.js": 84,
	"./globals/global.duck.js": 157,
	"./parts/modalBehaviour/modalBehaviour.duck.js": 601,
	"./parts/showMoreBehaviour/showMoreBehaviour.duck.js": 606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 897;